import { openkit } from "../../library/database";

const setProductsAsAvailable = (products) => {
  return products.map((p) => ({ ...p, status: "available" }));
};

export const searchEventTickets = async (store_id, info) => {
  try {
    const query = {
      store_id,
      date: info.event?.date,
    };
    const resp = await openkit.custom.execute(
      "post",
      "search-event-tickets",
      null,
      {
        query,
      }
    );
    const respWithAvailableStatus = setProductsAsAvailable(resp);
    return respWithAvailableStatus;
  } catch (error) {
    console.log("error :>> ", error);
  }
};
